import { useEffect, useState } from 'react'
import React from 'react'

import { ClientProposalCardVote } from '../client-proposal-card-vote/ClientProposalCardVote'
import { ClientProposalVoteEnum } from '../../../lib/graphql'

/**
 * A wrapper component for ClientProposalCardVote that manages vote state and interactions.
 * The purpose of this component is to have an instant reactivity of the vote count and user vote.
 */
export const ClientProposalCardVoteWrapper = ({
  upCount: dbUpCount,
  downCount: dbDownCount,
  userVote: dbUserVote,
  handleVote,
  clientProposalId,
}: {
  upCount: number
  downCount: number
  handleVote: ({
    clientProposalId,
    value,
  }: {
    clientProposalId: string
    value: ClientProposalVoteEnum | null
  }) => void
  userVote: ClientProposalVoteEnum | null
  clientProposalId: string
}) => {
  const [upCount, setUpCount] = useState(dbUpCount)
  const [downCount, setDownCount] = useState(dbDownCount)
  const [userVote, setUserVote] = useState<ClientProposalVoteEnum | null>(
    dbUserVote,
  )

  const onUpVoteClick = () => {
    if (userVote === ClientProposalVoteEnum.LIKE) {
      setUpCount(upCount - 1)
      setUserVote(null)
      handleVote({ clientProposalId, value: null })
      return
    }
    setUpCount(upCount + 1)
    if (userVote === ClientProposalVoteEnum.DISLIKE) {
      setDownCount(downCount - 1)
    }
    setUserVote(ClientProposalVoteEnum.LIKE)
    handleVote({ clientProposalId, value: ClientProposalVoteEnum.LIKE })
  }

  const onDownVoteClick = () => {
    if (userVote === ClientProposalVoteEnum.DISLIKE) {
      setDownCount(downCount - 1)
      setUserVote(null)
      handleVote({ clientProposalId, value: null })
      return
    }
    setDownCount(downCount + 1)
    if (userVote === ClientProposalVoteEnum.LIKE) {
      setUpCount(upCount - 1)
    }
    setUserVote(ClientProposalVoteEnum.DISLIKE)
    handleVote({ clientProposalId, value: ClientProposalVoteEnum.DISLIKE })
  }

  useEffect(() => {
    setUserVote(dbUserVote)
  }, [dbUserVote])

  return (
    <ClientProposalCardVote
      upCount={upCount}
      downCount={downCount}
      onUpVote={onUpVoteClick}
      onDownVote={onDownVoteClick}
      selectedVote={userVote}
    />
  )
}
